import { useContext } from 'react';

import { SearchResultContext } from '../context/SearchResultContext';

/**
 * Hook to access the current search result.
 * The component must be wrapped around the SearchResultContextProvider and have the searchResult set */
export const useSearchResultContext = () => {
    const context = useContext(SearchResultContext);

    return context;
};
